module.exports = __webpack_public_path__ + "static/media/ticket.0a53d1d6.svg";